import { useState } from "react";
import {
  TableRow,
  TableCell,
  Button,
  Chip,
  Typography,
  IconButton,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { grey } from "@mui/material/colors";

import { saveAs } from "file-saver";

import { statusMap } from "../InboxPage";

import { useBill } from "../../../Components/Contexts/Bill";
import { DownloadIconButton } from "../../../Components/Buttons";
import { BACKEND_URL } from "../../../helpers/variables";

export function FileRow({ file }) {
  const [downloadFile, setDownloadFile] = useState(null);
  const { setBill } = useBill();

  async function downloadS3File(file) {
    setDownloadFile(file);
    const response = await fetch(`${BACKEND_URL}/download_file?s3_key=${file["s3_key"]}`);
    const blob = await response.blob();
    setDownloadFile(null);

    const fileName = file["source_filename"]
    saveAs(blob, fileName);
  }

  const bills = file["bills"];
  bills.sort((a, b) => {
    const aPage = a?.page_numbers?.[0] ?? Number.MAX_SAFE_INTEGER;
    const bPage = b?.page_numbers?.[0] ?? Number.MAX_SAFE_INTEGER;

    return aPage - bPage;
  });

  return (
    <>
      {bills.length === 0 ? (
        <TableRow key={file["_id"]} sx={{ bgcolor: grey[100] }}>
          <TableCell colSpan={6} sx={{ borderRight: `1px solid ${grey[300]}` }}>
            <Typography
              fontWeight={"bold"}
              fontSize={13}
              color={"text.secondary"}
              sx={{ wordBreak: "break-all" }}
            >
              {file["source_filename"]}
            </Typography>
          </TableCell>
          <TableCell>Processing</TableCell>
          <TableCell
            sx={{ borderLeft: `1px solid ${grey[300]}` }}
            align="center"
          >
            {file["_id"] === downloadFile?.["_id"] ? (
              <CircularProgress />
            ) : (
              <DownloadIconButton onClick={() => downloadS3File(file)} />
            )}
          </TableCell>
        </TableRow>
      ) : (
        bills.map((bill, index) => {
          let bill_id = bill["_id"];
          let bill_status = bill["bill_status"];
          let isApprove = bill_status === 1;

          let status = null;
          if (typeof bill_status !== "undefined")
            status = statusMap[bill_status];

          return (
            <TableRow key={bill_id} sx={{ bgcolor: grey[100] }}>
              {index === 0 && (
                <TableCell
                  rowSpan={bills.length}
                  sx={{ borderRight: `1px solid ${grey[300]}` }}
                >
                  <Typography
                    fontWeight={"bold"}
                    fontSize={13}
                    color={"text.secondary"}
                    sx={{ wordBreak: "break-all" }}
                  >
                    {file["source_filename"]}
                  </Typography>
                </TableCell>
              )}

              <TableCell sx={{ wordBreak: "break-all" }}>
                {bill["vendor_name"] || "-"}
              </TableCell>
              <TableCell sx={{ wordBreak: "break-all" }}>
                {bill["invoice_number"] || "-"}
              </TableCell>
              <TableCell sx={{ wordBreak: "break-all" }}>
                {bill["invoice_date"] || "-"}
              </TableCell>
              <TableCell>{bill["invoice_amount"] || "-"}</TableCell>

              <TableCell align="center">
                <Tooltip
                  title={
                    Array.isArray(bill.page_numbers)
                      ? bill.page_numbers.join(", ")
                      : "No pages"
                  }
                  arrow
                >
                  {status ? (
                    <Chip color={status["color"]} label={status["name"]} />
                  ) : (
                    <span>Processing</span>
                  )}
                </Tooltip>
              </TableCell>

              <TableCell align="center">
                <Tooltip
                  hidden={isApprove}
                  title={bill["error_description"]}
                  arrow
                >
                  <Button
                    variant="contained"
                    disableElevation
                    onClick={(e) => setBill(bill)}
                    color={isApprove ? "success" : "primary"}
                  >
                    {isApprove ? "Posted" : "View"}
                  </Button>
                </Tooltip>
              </TableCell>

              {index === 0 && (
                <TableCell
                  rowSpan={bills.length}
                  sx={{ borderLeft: `1px solid ${grey[300]}` }}
                  align="center"
                >
                  {file["_id"] === downloadFile?.["_id"] ? (
                    <CircularProgress />
                  ) : (
                    <DownloadIconButton onClick={() => downloadS3File(file)} />
                  )}
                </TableCell>
              )}
            </TableRow>
          );
        })
      )}
    </>
  );
}
